import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { audienceTypes } from "@/mocks/solucoes";

export default function SolucoesAudience() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Para quem são nossas soluções"
          badgeIcon="ri-group-line"
          badgeTone="accent"
          title="Soluções para diferentes tipos de negócios"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {audienceTypes.map((item, index) => (
            <Reveal key={item.title} delay={(index % 3) * 60} className="h-full">
              <article className="flex h-full items-start gap-4 rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-accent-100/70 text-accent-700">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                    {item.description}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <p className="mx-auto mt-12 max-w-3xl text-center text-base leading-relaxed text-foreground-600">
            Seja para começar do zero ou melhorar uma estrutura existente, a{" "}
            <strong className="font-semibold text-foreground-900">NXHOST</strong> pode ajudar sua
            empresa a evoluir digitalmente.
          </p>
        </Reveal>
      </div>
    </section>
  );
}